import json2csv from "json2csv";

import * as a from "./action";
import * as s from "./selector";
// import { sendMessage } from "../Notifications";
import withActions from "../../utils/redux/withActions";
// import { startLoading, stopLoading } from "../Suspense";

const { setDeductions } = a;

const delay = (ms = 1000) =>
  new Promise((r) => {
    setTimeout(r, ms);
  });

const boundedActions = withActions({
  // sendMessage,
  // startLoading,
  // stopLoading,
  setDeductions,
});

export const fetchDeductions =
  () =>
  async (dispatch, getState, { history, remote }) => {
    // dispatch(startLoading());

    try {
      const liabilities = await remote(
        "get",
        `v3/customers/liabilities`,
        {},
        "get Liabilities cards",
        dispatch
      );

      dispatch(setDeductions(liabilities));
    } catch (error) {
      // dispatch(sendMessage("Failed to fetch deductions"));
    }

    // dispatch(stopLoading());
  };
